export enum AlertType {
  INFO,
  WARNING,
  ERROR,
  UPLOAD,
}
export default interface ApplicationAlert {
  type: AlertType;
  header: string;
  body: string;
  rowsUploaded?: number;
  rowsWithErrors?: number;
  numberOfErrors?: number;
  potentialDupes?: number;
  groupId?: string;
  ingestId?: string;
  logStatus?: string;
  loading?: boolean;
}
